(ns ncr.etc.alert
  (:require
   [clojure.string :as str]
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.reload :as rel]
   [ncr.etc.pf :as pf]
   [ncr.etc.util :as u]))

(defonce akey
  (atom 0))

(declare schedule-flash-messages)

(defn c-alert-container []
  (let
    [*alerts
     (rel/use-reload! ::c-alert-container
       (ps/sub-reducer-map! {}
         {::alert-add
          (fn [state key alert]
            (assoc state key alert))

          ::alert-update
          (fn [state key alert]
            (if (contains? state key)
              (assoc state key alert)
              state))

          ::alert-remove
          (fn [state id]
            (dissoc state id))}))
     alerts @*alerts]

    (uix/effect! schedule-flash-messages [])

    (when (seq alerts)
      [pf/c-alert-group {:is-toast true}
       (for [{:keys [key body is-progress progress-value] :as alert} (->> alerts vals (sort-by :key) reverse)]
         ^{:key key}
         [pf/c-alert
          (merge
            (select-keys alert [:variant :title])
            {:timeout false
             :action-close
             [pf/c-alert-action-close-button
              {:on-click
               #(ps/pub! [::alert-remove key])}]}
            (when is-progress
              {:custom-icon [pf/c-spinner {:size :md}]}))

          [:<>
           body
           (when progress-value
             [pf/c-progress {:aria-label :progress :value progress-value}])]])])))

(defn alert! [alert]
  (let [key (swap! akey inc)]
    (when alert
      (ps/pub!
        [::alert-add key
         (assoc alert :key key)]))
    key))

(defn update! [key alert]
  (when alert
    (ps/pub!
      [::alert-update key
       (assoc alert :key key)])))

(defn dispose! [key]
  (ps/pub! [::alert-remove key]))

(defn toast! [alert]
  (let [key (alert! alert)]
    (go
      (<! (async/timeout 8000))
      (dispose! key))))

(defn- schedule-flash-messages []
  (when-let [c (first
                 (filter #(str/starts-with? % "ncr-flash=")
                   (-> js/document .-cookie (str/split #";\s*"))))]
    (set! (.-cookie js/document)
      "ncr-flash=; expires=Thu, 01 Jan 1970 00:00:00 GMT")
    (try
      (let [msgs
            (-> c
              (str/split #"=" 2)
              last
              js/decodeURIComponent
              js/atob
              u/transit-read)]

        (doseq [{:keys [flavor title body cid] :or {flavor :error title flavor}}
                msgs

                :let [body
                      (cond-> body cid (str " (Correlation ID: " cid ")"))]]
          (let [variant ({:error :danger} flavor :danger)]
            (toast!
              {:variant variant
               :title (str/capitalize (name (or title flavor)))
               :body body}))))
      (catch js/Error e
        (.error js/console "Cookie Messages:" e)
        nil))))

(defn progress [initial]
  (let [ch (async/chan)]
    (let [alert (atom initial)]
      (async/go-loop []
        (match (async/alts! [ch (async/timeout 300)])
          [result ch]
          (when (some? result)
            (reset! alert result)
            (recur))

          _
          (let [key (alert! (assoc @alert :is-progress true))]
            (async/go-loop []
              (if-let [alert (<! ch)]
                (do
                  (update! key (assoc alert :is-progress true))
                  (recur))
                (dispose! key)))))))
    ch))

(defn !operation* [{:keys [operation-title success-title body body-fn]} progress result]
  (go
    (let
      [result (<! result)
       body' (if body-fn (body-fn result) body)]
      (async/close! progress)

      (u/if-ok [maybe-error result]
        (when (some? success-title)
          (toast!
            {:variant :success
             :title success-title
             :body body'}))

        (toast!
          {:variant :danger
           :title
           (if operation-title
             (u/format "%s: %s" operation-title maybe-error)
             (u/format "%s" maybe-error))
           :body body'}))
      result)))

(defn !operation [{:keys [operation-title body] :as props} ch]
  (!operation* props
    (progress {:title operation-title :body body}) ch))

(defn !fragment-operation [{:keys [fragments] :as props} ch]
  (let
    [body
     (if-let [{:keys [name]} (u/singleton fragments)]
       name
       (u/format "%s fragments" (count fragments)))]
    (!operation (assoc props :body body) ch)))